import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TableCell } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1),
    overflowX: 'auto',
  },
  weekSelectorContent: {
    color: 'black',
  },
  commentBox: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  attachFileButton: {
    background: theme.palette.primary.dark,
    maxHeight: 56,
    color: 'white',
    margin: theme.spacing(),
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  arrowIcons: {
    color: theme.palette.primary.dark,
  },
  textArea: {
    width: 200,
    overflow: 'auto',
  },
  rowButton: {
    margin: theme.spacing(1),
  },
  formControl: {
    minWidth: '70%',
  },
  gridElLeft: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  gridElRight: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
    },
  },
  columns: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  inputMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),

      // "&:hover": {
      //     backgroundColor: theme.palette.secondary.dark,
      // },
    },
    [theme.breakpoints.up('md')]: {
      // "&:hover": {
      //     backgroundColor: theme.palette.secondary.dark,
      // },
    },
  },
  btnMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
  },
  textFieldCont: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px',
  },
  dialogTitleContainer: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.dark,
    borderBottom: 'solid',
  },
  dialogTitle: {
    fontWeight: 'bold',
  },
  negativeBtn: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
}));

export const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.white,
  },
}))(TableCell);
